var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _rect5, _rect6, _path4, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderCompletedEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 149,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 15.5,
    width: 119,
    height: 119,
    rx: 3.5,
    fill: "white",
    stroke: "#F0F0F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.799 47.201C100.05 52.452 103 59.5739 103 67C103 65.1435 102.263 63.363 100.95 62.0503C99.637 60.7375 97.8565 60 96 60C94.1435 60 92.363 60.7375 91.0503 62.0503C89.7375 63.363 89 65.1435 89 67C89 65.1435 88.2625 63.363 86.9497 62.0503C85.637 60.7375 83.8565 60 82 60C80.1435 60 78.363 60.7375 77.0503 62.0503C75.7375 63.363 75 65.1435 75 67C75 65.1435 74.2625 63.363 72.9497 62.0503C71.637 60.7375 69.8565 60 68 60C66.1435 60 64.363 60.7375 63.0503 62.0503C61.7375 63.363 61 65.1435 61 67C61 65.1435 60.2625 63.363 58.9497 62.0503C57.637 60.7375 55.8565 60 54 60C52.1435 60 50.363 60.7375 49.0503 62.0503C47.7375 63.363 47 65.1435 47 67C47 59.5739 49.95 52.452 55.201 47.201C60.452 41.95 67.5739 39 75 39C82.4261 39 89.548 41.95 94.799 47.201Z",
    fill: "#C3C5D5",
    stroke: "#9799B5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66.5V67L62 90M103 66.5V67L88 90M89 66V67L82 89M61 66V67L68 89M75 66V89",
    stroke: "#9799B5",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61 90C61 89.4477 61.4477 89 62 89H88C88.5523 89 89 89.4477 89 90V112C89 112.552 88.5523 113 88 113H62C61.4477 113 61 112.552 61 112V90Z",
    fill: "#F0F0F4",
    stroke: "#9799B5",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 104,
    width: 5,
    height: 1,
    rx: 0.5,
    fill: "#C3C5D5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 106,
    width: 7,
    height: 1,
    rx: 0.5,
    fill: "#C3C5D5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 108,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#C3C5D5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 104,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#C3C5D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73 90H77V95C77 95.5523 76.5523 96 76 96H74C73.4477 96 73 95.5523 73 95V90Z",
    fill: "#C3C5D5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 149,
    rx: 9.5,
    stroke: "#F0F0F4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCompletedEmpty);
export default __webpack_public_path__ + "static/media/orderCompletedEmpty.39eb179b173e2bbab48b4f9bf47547d6.svg";
export { ForwardRef as ReactComponent };